import React from 'react';
import whatsapp from "../../assets/icon/whatappFloat.svg"

const WhatsAppFloatButton = () => {
  return (
    <a 
      href="https://wa.me/918825532600" 
      target="_blank" 
      rel="noopener noreferrer"
       className="fixed top-3/4 md:right-8 right-2 transform -translate-y-3/4 z-50 animate-bounce"
    >
      <img
        loading="lazy"
        src={whatsapp}
        alt="WhatsApp Contact"
        className="w-10 h-10 hover:scale-110 transition-transform"
      />
    </a>
  );
};

export default WhatsAppFloatButton;